// TelcoTrack — Úřady: identita správce z overlay WFS (IČO / DS), ne obecný tip.

export const RSD_ICO = '65993390';
export const RSD_NAME_CS = 'Ředitelství silnic a dálnic s. p.';
/** Oficiální podatelna https://www.rsd.cz/kontakty (2026-09). */
export const RSD_EMAIL = 'posta@rsd.cz';
export const RSD_DATA_BOX_ID = 'zjq4rhz';
export const RSD_PHONE = '+420 954 901 111';

/** ARES: Lesy České republiky, s.p. (42196417 v zadání není LČR). */
export const LESY_CR_ICO = '42196451';
export const LESY_CR_NAME_CS = 'Lesy České republiky, s.p.';
/** Oficiální e-podatelna https://reditelstvi.lesycr.cz/podatelna/ (2026-09). */
export const LESY_CR_EMAIL = 'podatelna@lesycr.cz';
export const LESY_CR_DATA_BOX_ID = 'e8jcfsn';
export const LESY_CR_PHONE = '+420 956 999 111';

export interface AuthorityOverlayContact {
  name: string;
  ico?: string;
  dataBoxId?: string;
  /** Sídlo z ARES / adresáře. */
  address?: string;
  /** Jen z adresáře / ručního zápisu — ARES/SDS e-mail neposkytují. */
  email?: string;
  /** Jen z adresáře / ručního zápisu — ARES/SDS telefon neposkytují. */
  phone?: string;
  region?: string;
  unit?: string;
  source: 'overlay';
}

export interface AuthoritySusIcoRow {
  regionKey: string;
  labelCs: string;
  name: string;
  ico: string;
  /** Oficiální e-podatelna / podatelna z webu organizace (ověřeno 2026-09). */
  email?: string;
  /** ID datové schránky z webu organizace / SDS (ověřeno 2026-09). */
  dataBoxId?: string;
  /** Telefon podatelny / ústředny z webu organizace (ověřeno 2026-09). */
  phone?: string;
}

/**
 * 14 krajských správců silnic II./III. třídy — IČO ověřená v ARES,
 * podatelny (e-mail / DS / telefon) ověřené na webech organizací (2026-09).
 */
export const AUTHORITY_SUS_ICOS: readonly AuthoritySusIcoRow[] = [
  {
    regionKey: 'praha',
    labelCs: 'Praha',
    name: 'Technická správa komunikací hl. m. Prahy, a.s.',
    ico: '03447286',
    email: 'tsk@tsk-praha.cz',
    dataBoxId: 'mivq4t3',
    phone: '+420 257 015 111',
  },
  {
    regionKey: 'stredocesky',
    labelCs: 'Středočeský',
    name: 'Krajská správa a údržba silnic Středočeského kraje, příspěvková organizace',
    ico: '00066001',
    email: 'podatelna@ksus.cz',
    dataBoxId: 'a6ejgmx',
    phone: '+420 257 280 612',
  },
  {
    regionKey: 'jihocesky',
    labelCs: 'Jihočeský',
    name: 'Správa a údržba silnic Jihočeského kraje',
    ico: '70971641',
    email: 'sekretariat@susjk.cz',
    dataBoxId: 'cadk8eb',
    phone: '+420 387 021 011',
  },
  {
    regionKey: 'plzensky',
    labelCs: 'Plzeňský',
    name: 'Správa a údržba silnic Plzeňského kraje, příspěvková organizace',
    ico: '72053119',
    email: 'posta@suspk.eu',
    dataBoxId: 'qbep485',
    phone: '+420 377 172 403',
  },
  {
    regionKey: 'karlovarsky',
    labelCs: 'Karlovarský',
    name: 'Krajská správa a údržba silnic Karlovarského kraje, příspěvková organizace',
    ico: '70947023',
    email: 'podatelna@ksusk.cz',
    dataBoxId: '2kdkk64',
    phone: '+420 352 356 104',
  },
  {
    regionKey: 'ustecky',
    labelCs: 'Ústecký',
    name: 'Správa a údržba silnic Ústeckého kraje, příspěvková organizace',
    ico: '00080837',
    email: 'dubi.tp@susuk.cz',
    dataBoxId: '6hevxje',
    phone: '+420 417 532 235',
  },
  {
    regionKey: 'liberecky',
    labelCs: 'Liberecký',
    name: 'Krajská správa silnic Libereckého kraje, příspěvková organizace',
    ico: '70946078',
    email: 'posta@ksslk.cz',
    dataBoxId: 'bdnkk7w',
    phone: '+420 484 809 111',
  },
  {
    regionKey: 'kralovehradecky',
    labelCs: 'Královéhradecký',
    name: 'Správa silnic Královéhradeckého kraje',
    ico: '70947996',
    email: 'sskhk@sskhk.cz',
    dataBoxId: '6m8k8ey',
    phone: '+420 725 930 598',
  },
  {
    regionKey: 'pardubicky',
    labelCs: 'Pardubický',
    name: 'Správa a údržba silnic Pardubického kraje',
    ico: '00085031',
    email: 'podatelna@suspk.cz',
    dataBoxId: 'ffhk8fq',
    phone: '+420 466 052 765',
  },
  {
    regionKey: 'vysocina',
    labelCs: 'Vysočina',
    name: 'Krajská správa a údržba silnic Vysočiny, příspěvková organizace',
    ico: '00090450',
    email: 'ksusv@ksusv.cz',
    dataBoxId: '3qdnp8g',
    phone: '+420 567 117 158',
  },
  {
    regionKey: 'jihomoravsky',
    labelCs: 'Jihomoravský',
    name: 'Správa a údržba silnic Jihomoravského kraje, příspěvková organizace kraje',
    ico: '70932581',
    email: 'podatelna@susjmk.cz',
    dataBoxId: 'k3nk8e7',
    phone: '+420 547 120 311',
  },
  {
    regionKey: 'olomoucky',
    labelCs: 'Olomoucký',
    name: 'Správa silnic Olomouckého kraje, příspěvková organizace',
    ico: '70960399',
    email: 'ssok@ssok.cz',
    dataBoxId: 'ur4k8nn',
    phone: '+420 585 170 311',
  },
  {
    regionKey: 'zlinsky',
    labelCs: 'Zlínský',
    name: 'Ředitelství silnic Zlínského kraje, příspěvková organizace',
    ico: '70934860',
    email: 'podatelna@rszk.cz',
    dataBoxId: 'jjfsbqc',
    phone: '+420 577 212 829',
  },
  {
    regionKey: 'moravskoslezsky',
    labelCs: 'Moravskoslezský',
    name: 'Správa silnic Moravskoslezského kraje, příspěvková organizace',
    ico: '00095711',
    email: 'ssmsk@ssmsk.cz',
    dataBoxId: 'jytk8nr',
    phone: '+420 595 135 911',
  },
] as const;

const POVODI_ICO_BY_NEEDLE: ReadonlyArray<{
  needle: string;
  name: string;
  ico: string;
  email?: string;
  dataBoxId?: string;
  phone?: string;
}> = [
  {
    needle: 'povodi labe',
    name: 'Povodí Labe, státní podnik',
    ico: '70890005',
    email: 'podatelna@pla.cz',
    dataBoxId: 'dbyt8g2',
    phone: '+420 495 088 111',
  },
  {
    needle: 'povodi vltavy',
    name: 'Povodí Vltavy, státní podnik',
    ico: '70889953',
    email: 'podatelna@pvl.cz',
    dataBoxId: 'gg4t8hf',
    phone: '+420 221 401 111',
  },
  {
    needle: 'povodi ohre',
    name: 'Povodí Ohře, státní podnik',
    ico: '70889988',
    email: 'podatelna@poh.cz',
    dataBoxId: '7ptt8gm',
    phone: '+420 474 636 111',
  },
  {
    needle: 'povodi odry',
    name: 'Povodí Odry, státní podnik',
    ico: '70890021',
    email: 'info@pod.cz',
    dataBoxId: 'wwit8gq',
    phone: '+420 596 657 111',
  },
  {
    needle: 'povodi moravy',
    name: 'Povodí Moravy, s.p.',
    ico: '70890013',
    email: 'podatelna@pmo.cz',
    dataBoxId: 'm49t8gw',
    phone: '+420 541 637 111',
  },
  {
    needle: 'lesy ceske republiky',
    name: LESY_CR_NAME_CS,
    ico: LESY_CR_ICO,
    email: LESY_CR_EMAIL,
    dataBoxId: LESY_CR_DATA_BOX_ID,
    phone: LESY_CR_PHONE,
  },
  {
    needle: 'lesy cr',
    name: LESY_CR_NAME_CS,
    ico: LESY_CR_ICO,
    email: LESY_CR_EMAIL,
    dataBoxId: LESY_CR_DATA_BOX_ID,
    phone: LESY_CR_PHONE,
  },
];

const SPRAVCE_TOKU_KEYS = [
  'SPR_TOKU',
  'SPRAVCE_TOKU',
  'SPR_NAZ',
  'NAZ_SPR',
  'NAZEV_SPR',
  'SPR_NAZEV',
  'NAZEV_SPRAVCE',
  'SPRAVCE_NAZEV',
  'CEVT_SPR',
  'SPR_SUBJEKT',
  'ORGANIZACE_SPR',
  'SPRAVCE',
];

const AOPK_RP_NAME_KEYS = ['NAZEV_RP', 'NAZEV'];
const AOPK_RP_DS_KEYS = ['ID_DATSCHR', 'ID_DS', 'DATOVA_SCHRANKA'];
const AOPK_RP_ADDR_KEYS = ['ADRESA_RP', 'ADRESA'];

export function foldOverlayIdentityText(value: string | null | undefined): string {
  return (value ?? '')
    .toLocaleLowerCase('cs')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export function pickWfsProperty(
  properties: Record<string, unknown> | null | undefined,
  keys: readonly string[],
): string | null {
  if (!properties) return null;
  const exact = new Map(Object.keys(properties).map((key) => [key.toLowerCase(), key]));
  for (const key of keys) {
    const found = exact.get(key.toLowerCase());
    const value = String(found ? properties[found] ?? '' : '').trim();
    if (value) return value;
  }
  return null;
}

/** Kontakt jen při IČO nebo ID DS z vrstvy / tabulky. Název samotný nestačí. */
export function overlayContactFromIdentity(input: {
  name?: string | null;
  ico?: string | null;
  dataBoxId?: string | null;
  address?: string | null;
  email?: string | null;
  phone?: string | null;
  region?: string | null;
  unit?: string | null;
}): AuthorityOverlayContact | null {
  const ico = normalizeIco(input.ico);
  const dataBoxId = normalizeDataBoxId(input.dataBoxId);
  if (!ico && !dataBoxId) return null;
  const name = (input.name ?? '').trim() || (input.unit ?? '').trim();
  if (!name) return null;
  const contact: AuthorityOverlayContact = { name, source: 'overlay' };
  if (ico) contact.ico = ico;
  if (dataBoxId) contact.dataBoxId = dataBoxId;
  const address = (input.address ?? '').trim();
  if (address) contact.address = address;
  const email = (input.email ?? '').trim();
  if (email) contact.email = email;
  const phone = (input.phone ?? '').trim();
  if (phone) contact.phone = phone;
  const region = (input.region ?? '').trim();
  if (region) contact.region = region;
  const unit = (input.unit ?? '').trim();
  if (unit && unit !== name) contact.unit = unit;
  return contact;
}

export function overlayContactLabel(
  contact?: AuthorityOverlayContact | null,
  gapReason?: string | null,
): string {
  if (contact) {
    const parts: string[] = [];
    const name = contact.name.trim();
    if (name) parts.push(name);
    if (contact.ico) parts.push(`IČO ${contact.ico}`);
    if (contact.dataBoxId) parts.push(`DS ${contact.dataBoxId}`);
    if (parts.length && !contact.dataBoxId && !(contact.email ?? '').trim()) {
      parts.push('subjekt známý, kontakt chybí');
    }
    if (parts.length) return parts.join(' · ');
  }
  const gap = (gapReason ?? '').trim();
  return gap || 'Kontakt nedohledán';
}

/** Proč je sloupec Správce prázdný — ne tiché „—“. */
export function overlayContactGapReason(
  subjectKey: string,
  opts?: { region?: string | null; hasSpravceToku?: boolean },
): string {
  const key = subjectKey.trim();
  if (key === 'povodi') {
    return opts?.hasSpravceToku === false || opts?.hasSpravceToku == null
      ? 'Ve vrstvě chybí správce toku (SPR_TOKU) mapovatelný na IČO'
      : 'Správce toku se nepodařilo mapovat na jednoznačné IČO';
  }
  if (key === 'sus') {
    return opts?.region?.trim()
      ? `Kraj „${opts.region.trim()}“ není v tabulce SÚS IČO`
      : 'Chybí kraj stavby (metadata.administrativeData.kraj)';
  }
  if (key === 'cgs_chlu') {
    return 'Doplňte regionální Obvodní báňský úřad — v návrhu je ČBÚ (centrální)';
  }
  return 'Bez jednoznačného IČO/DS z vrstvy, známého subjektu ani adresáře';
}

/** DIBAVOD / CEVT — jen atribut správce toku, ne NAZ_POVODI. */
export function extractSpravceToku(properties: Record<string, unknown> | null | undefined): string | null {
  return pickWfsProperty(properties, SPRAVCE_TOKU_KEYS);
}

export function povodiContactFromProperties(
  properties: Record<string, unknown> | null | undefined,
): AuthorityOverlayContact | null {
  const spravce = extractSpravceToku(properties);
  if (!spravce) return null;
  const mapped = povodiIcoFromSpravce(spravce);
  return overlayContactFromIdentity({
    name: mapped?.name ?? spravce,
    ico: mapped?.ico ?? null,
    email: mapped?.email ?? null,
    dataBoxId: mapped?.dataBoxId ?? null,
    phone: mapped?.phone ?? null,
  });
}

export function povodiIcoFromSpravce(
  spravce: string,
): { name: string; ico: string; email?: string; dataBoxId?: string; phone?: string } | null {
  const folded = foldOverlayIdentityText(spravce);
  if (!folded) return null;
  const hits = POVODI_ICO_BY_NEEDLE.filter((row) => folded.includes(row.needle));
  if (hits.length !== 1) return null;
  const hit = hits[0];
  return {
    name: hit.name,
    ico: hit.ico,
    email: hit.email,
    dataBoxId: hit.dataBoxId,
    phone: hit.phone,
  };
}

export function aopkRpContactFromProperties(
  properties: Record<string, unknown> | null | undefined,
): AuthorityOverlayContact | null {
  const name = pickWfsProperty(properties, AOPK_RP_NAME_KEYS);
  const dataBoxId = pickWfsProperty(properties, AOPK_RP_DS_KEYS);
  const address = pickWfsProperty(properties, AOPK_RP_ADDR_KEYS);
  return overlayContactFromIdentity({
    name: name || (address ? `AOPK ${address}` : null),
    dataBoxId,
    unit: name,
  });
}

export function isLesyCrOrgFeature(properties: Record<string, unknown> | null | undefined): boolean {
  if (!properties) return false;
  const ls = pickWfsProperty(properties, ['LS_NAZ', 'LS']);
  const zavod = pickWfsProperty(properties, ['OBR_NAZ', 'OI_NAZ_UPPER', 'OBR']);
  return Boolean(ls || zavod);
}

export function extractLesyOrgUnit(properties: Record<string, unknown> | null | undefined): string | null {
  const ls = pickWfsProperty(properties, ['LS_NAZ']);
  if (ls) return `LS ${ls}`;
  const zavod = pickWfsProperty(properties, ['OBR_NAZ', 'OI_NAZ_UPPER']);
  return zavod;
}

export function lesyCrContactFromProperties(
  properties: Record<string, unknown> | null | undefined,
): AuthorityOverlayContact | null {
  if (!isLesyCrOrgFeature(properties)) return null;
  const unit = extractLesyOrgUnit(properties);
  return overlayContactFromIdentity({
    name: unit ? `${LESY_CR_NAME_CS} — ${unit}` : LESY_CR_NAME_CS,
    ico: LESY_CR_ICO,
    email: LESY_CR_EMAIL,
    dataBoxId: LESY_CR_DATA_BOX_ID,
    phone: LESY_CR_PHONE,
    unit,
  });
}

export function rsdContactFromHit(): AuthorityOverlayContact | null {
  return overlayContactFromIdentity({
    name: RSD_NAME_CS,
    ico: RSD_ICO,
    email: RSD_EMAIL,
    dataBoxId: RSD_DATA_BOX_ID,
    phone: RSD_PHONE,
  });
}

export function normalizeCzechRegionKey(region: string | null | undefined): string | null {
  let folded = foldOverlayIdentityText(region);
  if (!folded) return null;
  folded = folded
    .replace(/^kraj\s+/, '')
    .replace(/\s+kraj$/, '')
    .replace(/^hlavni mesto\s+/, '')
    .replace(/^hl m\s+/, '')
    .replace(/^hlm\s+/, '')
    .trim();
  if (folded === 'hlavni mesto praha' || folded === 'praha hlavni mesto' || folded === 'hl m praha') {
    return 'praha';
  }
  if (folded === 'vysocina' || folded === 'kraj vysocina') return 'vysocina';
  return folded || null;
}

export function susContactForRegion(region: string | null | undefined): AuthorityOverlayContact | null {
  const key = normalizeCzechRegionKey(region);
  if (!key) return null;
  const row = AUTHORITY_SUS_ICOS.find((item) => item.regionKey === key);
  if (!row) return null;
  return overlayContactFromIdentity({
    name: row.name,
    ico: row.ico,
    email: row.email ?? null,
    dataBoxId: row.dataBoxId ?? null,
    phone: row.phone ?? null,
    region: row.labelCs,
  });
}

/** Krajský klíč SÚS z IČO — 14 známých správců, jinak null. */
export function susRegionKeyFromIco(ico: string | null | undefined): string | null {
  const normalized = normalizeIco(ico);
  if (!normalized) return null;
  return AUTHORITY_SUS_ICOS.find((item) => item.ico === normalized)?.regionKey ?? null;
}

/** Stejný krajský klíč z IČO (preferováno) nebo z názvu kraje. */
export function susRegionKeyFromPlace(place: {
  ico?: string | null;
  region?: string | null;
}): string | null {
  return susRegionKeyFromIco(place.ico) ?? normalizeCzechRegionKey(place.region);
}

export function normalizeIco(value: string | null | undefined): string | null {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length < 4 || digits.length > 8) return null;
  return digits.padStart(8, '0');
}

function normalizeDataBoxId(value: string | null | undefined): string | null {
  const raw = String(value ?? '').trim().toLowerCase();
  if (!raw) return null;
  if (!/^[a-z0-9]{6,7}$/.test(raw)) return null;
  return raw;
}
